/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import * as React from "react";
import { GRID_TREE_DATA_GROUPING_FIELD } from "@mui/x-data-grid-pro";
import { useInventoryData } from "./hooks";
import CustomTreeDataGridPro from "../../../components/Shared/Table/CustomTreeDataGridPro";
import ConnectRFFeed from "../../../components/Configuration/Inventory/ConnectRFFeed";
import { DIALOGOPENFOR } from "../../../globals/globals";
import { useSelector } from "react-redux";
import { basicDialogSelector } from "../../../store/helpers/helperSelectors";
import { Button } from "../../../components/ui/button";
import { useStoreDispatch } from "../../../store/hooks";
import { setBasicDialogOpenFor } from "../../../store/helpers/helperReducers";
import { selectProfilePermissionsSelector } from "../../../store/api/auth/selectors";
import ProfilePermissions from "../../../utils/ProfilePermissions";
import { Cable } from "lucide-react";

const Inventory = () => {
  const dispatch = useStoreDispatch();
  const { data, InventoryColumns } = useInventoryData();
  const basicDialogOpenFor = useSelector(basicDialogSelector);
  const permissions: ProfilePermissions | null = useSelector(selectProfilePermissionsSelector);

  const ConnectRFFeedHandler = () => {
    dispatch(setBasicDialogOpenFor(DIALOGOPENFOR.CONNECTRFFEED));
  };

  const treeDataProSxProps = {
    "& .MuiDataGrid-overlayWrapper": { height: 52 },
    "& .MuiDataGrid-pinnedColumnHeaders--right": { paddingRight: "0 !important" },
    maxHeight: 600,
  };
  return (
    <>
      {basicDialogOpenFor === DIALOGOPENFOR.CONNECTRFFEED && <ConnectRFFeed />}
      <div className="w-full">
        <div
          style={{
            minHeight: "300px",
            border: "1px solid var(--color-border)",
            borderRadius: "var(--radius)",
            padding: "18px",
            boxShadow: "var(--shadow-card)",
            backgroundColor: "var(--card)",
          }}
        >
          {permissions?.hasOpCodeGroup("manage_topology") && (
            <div className="flex justify-end pt-4 pb-4">
              <Button
                onClick={ConnectRFFeedHandler}
                variant="outline"
                className="
                  h-10
                  px-4
                  text-sm
                  font-medium
                  border
                  border-input
                  bg-background
                  shadow-sm
                  flex
                  items-center
                  gap-2
                  hover:bg-muted
                  hover:text-accent-foreground
                  transition-colors
                "
              >
                <Cable className="h-4 w-4" />
                Connect RF Feed
              </Button>
            </div>
          )}
          <div>
            <CustomTreeDataGridPro
              tableId="inventory"
              sx={treeDataProSxProps}
              rows={data}
              getRowId={(row: any) => row.id}
              columns={InventoryColumns}
              pinnedColumns={{ left: [GRID_TREE_DATA_GROUPING_FIELD, "type"] }}
              hideFooter={true}
              groupHeaderName="Devices"
              fillContainer={false}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Inventory;